/** Bara en ikryssad funktion räknas. En rad utan action ger inte alla funktioner. */
export function hasExplicitFeatureAction(
  permissions: { feature?: { code?: string }; action?: { code?: string } | null }[] | undefined,
  featureCode: string,
  actionCode: string,
): boolean {
  return (permissions ?? []).some(
    (permission) => permission.feature?.code === featureCode && permission.action?.code === actionCode,
  );
}
